module.exports = __webpack_public_path__ + "static/media/banner.23d0e987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = 814
// module chunks = 0